export default __webpack_public_path__ + "assets/Printful_11_oz_mug.2efc83a8.glb";